import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DemoMaterialModule } from '../demo-material-module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Theme } from './service/AutoTheme';
import { AuthGuard } from '../authentication/guard/auth.guard';
import { AuthenticationService } from '../authentication/authentication.service';
import { JwtInterceptor } from '../authentication/helper/jwt.interceptor';
import { ErrorInterceptor } from '../authentication/helper/error.interceptor';
import { UploadviewComponent } from './uploadview/uploadview.component';
import { DispositionDetailsComponent } from './disposition-details/disposition-details.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { MenuService } from './sidebar/menu.service';
import { FormdetailComponent } from './formdetail/formdetail.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { StatusComponent } from './status/status.component';
import { Customdisposition1Component } from './customdisposition1/customdisposition1.component';

import { NgxPaginationModule } from 'ngx-pagination'
import { MatDialogModule, MatSnackBarModule } from '@angular/material';
import { TexteditorComponent } from './texteditor/texteditor.component';
import { CustomvariableComponent } from './customvariable/customvariable.component';
import { QuillModule } from 'ngx-quill';
import { ReportComponent, ReportsService, NgbdSortableHeader } from './report/report.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LeadGroupComponent } from './lead-group/lead-group.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AgentGroupComponent } from './agent-group/agent-group.component';
import { MapleadfeldAgentComponent } from './mapleadfeld-agent/mapleadfeld-agent.component';
import { LeadService } from '../leads/lead.service';
import { DidGroupComponent } from './did-group/did-group.component';
import { SampleDataComponent } from './sample-data/sample-data.component';
import { ScriptEditorComponent } from './script-editor/script-editor.component';
import { ScriptService, SettingService } from '../setting/setting.service';
import { AddAgentComponent } from './add-agent/add-agent.component';
import { AlertComponent } from './alert/alert.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { LeadDetailsComponent } from './lead-details/lead-details.component';
import { DidDetailsComponent } from './did-details/did-details.component';
import { LeadService as leadservernew } from '../leads/lead.service';
import { DidService } from '../dids/did.service';
import { AddAgentMultipleComponent } from './add-agent-multiple/add-agent-multiple.component';
import { ReportManagerComponent } from './report-manager/report-manager.component';
// import { PipeNamePipe } from './pipe-name.pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AddamountComponent } from './addamount/addamount.component';
import { ProfileService } from '../profile/profile.service';
import { CreditamountComponent } from './creditamount/creditamount.component';
import { MappingReportComponent } from './mapping-report/mapping-report.component';


import { EmailgroupsComponent } from './emailgroups/emailgroups.component';
import { AddemailsComponent } from './addemails/addemails.component';
import { SmtpemailComponent } from './smtpemail/smtpemail.component';
import { MapemailComponent } from './mapemail/mapemail.component';
import { LoaderComponent } from './loader/loader.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { ResendVerificationDialogComponent } from './verify-email/resend-verification-dialog/resend-verification-dialog.component';
// import { JsonParserPipe } from './pipes/json-parser.pipe';

/* 
 import * as FusionCharts from "fusioncharts";
 import * as Charts from "fusioncharts/fusioncharts.charts";
 import { FusionChartsModule } from 'angular-fusioncharts'; */
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DemoMaterialModule,
    FormsModule,
    FormsModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    MDBBootstrapModule,
    ChartsModule,
    NgxPaginationModule,
    MatSnackBarModule,
    //  CKEditorModule,
    NgApexchartsModule,
    QuillModule.forRoot(),
    ReactiveFormsModule,
    QuillModule,
    MatDialogModule,
    NgMultiSelectDropDownModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    })

  ],
  declarations: [
    DispositionDetailsComponent,
    UploadviewComponent,
    FormdetailComponent,
    ProgressbarComponent,
    StatusComponent,
    Customdisposition1Component,
    TexteditorComponent,
    CustomvariableComponent,
    ReportComponent,
    NgbdSortableHeader,
    LeadGroupComponent,
    AgentGroupComponent,
    MapleadfeldAgentComponent,
    DidGroupComponent,
    SampleDataComponent,
    ScriptEditorComponent,
    AddAgentComponent,
    AlertComponent,
    ComingSoonComponent,
    // JsonParserPipe
    LeadDetailsComponent,
    DidDetailsComponent,
    LoaderComponent,
    AddAgentMultipleComponent,
    ReportManagerComponent,
    AddamountComponent,CreditamountComponent, MappingReportComponent,
    EmailgroupsComponent,
    AddemailsComponent,
    SmtpemailComponent,
    MapemailComponent,
    VerifyEmailComponent,
    ResendVerificationDialogComponent


  ],
  exports: [
    UploadviewComponent,
    FormdetailComponent,
    ProgressbarComponent,
    StatusComponent,
    ReportComponent,
    Customdisposition1Component,
    NgbdSortableHeader,
    LeadGroupComponent,
    AgentGroupComponent,
    MapleadfeldAgentComponent,
    DidGroupComponent,
    AlertComponent,
    ComingSoonComponent,
    ReportManagerComponent,
    AddamountComponent,
    MappingReportComponent,
    LoaderComponent,
    VerifyEmailComponent
  
    // JsonParserPipe
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AuthGuard, AuthenticationService, DatePipe, Theme, MenuService, ReportsService, LeadService, ScriptService, SettingService, leadservernew, DidService,ProfileService
  ],
  entryComponents: [SampleDataComponent, MapleadfeldAgentComponent,AddamountComponent,VerifyEmailComponent,ResendVerificationDialogComponent]
})

export class SharedModule { }
// mport { NgbdSortableHeader, ReportComponent } from './report/report.component';
// import { NgApexchartsModule } from 'ng-apexcharts';


